export function useBreakpoints(): "xs"|"sm"|"md"|"lg"|"xl"|"xxl" {
    const width = window.innerWidth;
    if(width < 576) {
        return "xs";
    }
    else if(width >= 576 && width < 768) {
        return "sm";
    }
    else if(width >= 768 && width < 992) {
        return "md";
    }
    else if(width >= 992 && width < 1200) {
        return "lg";
    }
    else if(width >= 1200 && width < 1400) {
        return "xl";
    }
    else {
        return "xxl";
    }

}

export function useIsMobile(): boolean {
    const breakpoint = useBreakpoints();
    switch(breakpoint) {
        case "xs":
        case "sm":
        case "md":
            return true;
        case "lg":
        case "xl":
        case "xxl":
            return false;
    }
}